import {
  UserGroupIcon,
  ChatBubbleLeftIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';
import AboutContentModal from './AboutContentModal';
import ContentSectionManager from './ContentSectionManager';

const initialSections = [
  { title: 'Page Header', icon: RocketLaunchIcon },
  { title: 'Mission', icon: RocketLaunchIcon },
  { title: 'Committee', icon: UserGroupIcon },
  { title: 'Testimonials', icon: ChatBubbleLeftIcon },
];

export default function AboutContentContainer() {
  return (
    <ContentSectionManager
      page="about"
      initialSections={initialSections}
      ModalComponent={AboutContentModal}
    />
  );
}
